import React from 'react';
import ResponsiveModal from '../../common/ResponsiveModal';
import InviteForm from './InviteForm';

/**
 * InviteModal Component
 * Modal wrapper for the InviteForm component
 */
const InviteModal = ({ isOpen, onSave, onCancel, loading }) => {
  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onCancel}
      title="Send New Invite"
      maxWidth="lg"
    >
      <div className="p-6">
        <InviteForm
          onSave={onSave}
          onCancel={onCancel}
          loading={loading}
          isModal={true}
        />
      </div>
    </ResponsiveModal>
  );
};

export default InviteModal;